<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col>
        <v-alert
          dense
          outlined
          elevation="1"	
          type="info"
          color="blue"
          class="pa-2"
        >
          <b>• Qualquer alteração realizada nesta ferramenta será aplicada de maneira <u class="cPrimary">individual</u> no sistema conectado. <u class="cPrimary">Para que as alterações sejam concluídas</u>, é necessário que os usuários realizem o <u class="cPrimary">logout</u> e, em seguida, efetuem o <u class="cPrimary">login</u> novamente no sistema.</b>
          <br><br>
          <b>• <u class="cPrimary">Em breve</u> será implementado na tela de listagem um botão para <u class="cPrimary">replicar as alterações em outras empresas</u>.</b>
        </v-alert>
        <base-material-card
          color="primary"
          icon="mdi-lightning-bolt"
          inline
          class="ml-0 px-5 py-3"
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Power Ups
            </div>
          </template>
          <v-btn
            color="success"
            dark
            elevation="1"
            class="mt-5"
            style="float: left"
            relative
            text
            medium
            @click="$router.push('/administracao/powerups/edit')"
          >
            <v-icon
              left
              size="30px"
            >
              mdi-plus-circle
            </v-icon>
            Novo Power UP
          </v-btn>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="break-search bs-powerups ml-auto mt-4"
            label="Procurar"
            hide-details
            single-line
            style="max-width: 250px"
          />
          <v-divider class="mt-10" />
          <v-data-table
            class="powerups-table"
            :headers="headers"
            :items="items"
            :search.sync="search"
            :header-props="{
              sortByText: 'Ordenar Por'
            }"
            :footer-props="{
              itemsPerPageText: 'Itens por Página'
            }"
            :loading="loading"
            no-data-text="Nenhum power up disponível"
            no-results-text="Nenhum registro correspondente encontrado"
            :mobile-breakpoint="800"
          >
            <template v-slot:[`item.tipo`]="{ item }">
              {{ filtrarTipo(item.tipo) }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span
                style="font-weight: bold"
                :style="item.status ? 'color: green' : 'color: red'"
              >
                {{ item.status ? 'Ativo' : 'Inativo' }}
              </span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                min-width="0"
                class="ml-n1 px-1"
                fab
                icon
                x-small
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon 
                      small
                      :color="!item.status ? 'green' : 'red'"
                      v-bind="attrs" 
                      v-on="on"
                      @click="alterarStatus(item)"
                    >
                      {{ item.status ? 'mdi-thumb-down-outline' : 'mdi-thumb-up-outline' }}
                    </v-icon>
                  </template>
                  <span>{{ item.status ? "Inativar Ferramenta" : "Ativar Ferramenta" }}</span>
                </v-tooltip>
              </v-btn>
              <v-btn
                min-width="0"
                class="ml-n1 px-1"
                fab
                icon
                x-small
                @click="$router.push(`powerups/edit/${item.id}`)"
              >
                <v-icon small>
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
            <template v-slot:[`footer.page-text`]>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click="getAll()"
                  >
                    mdi-refresh
                  </v-icon>
                </template>
                <span>Clique aqui para recarregar os power-ups</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FerramentasService from '@/services/FerramentasService';

export default {
  data: () => ({
    items: [],
    search: undefined,
    headers: [
      {
        text: '#',
        value: 'id'
      },
      {
        text: 'Nome',
        value: 'nome'
      },
      {
        text: 'Tipo',
        value: 'tipo'
      },
      {
        text: 'Categoria',
        value: 'categoria'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        sortable: false,
        text: 'Ações',
        value: 'actions',
        class: 'pl-3'
      }
    ],
    loading: false
  }),

  mounted() {
    this.getAll();
  },

  methods: {
    getAll() {
      this.loading = true;
      this.items = [];
      
      FerramentasService.getAll()
        .then(response => this.items = response.data.ferramentas)
        .catch (error => {
          console.error(error);
          this.$toast.error('Erro ao recuperar as ferramentas.', '', {position:'topRight'});
        }) 
        .finally(() => this.loading = false);
    },

    alterarStatus(ferramenta) {
      FerramentasService.atualizarStatus(ferramenta.id, !ferramenta.status)
        .then((response) => {
          this.$toast.success(response.data.msg, '', { position: 'topRight', timeout: 6000 });
          this.getAll();
        })
        .catch(err => {
          if (err?.data?.error_code == 120) {
            this.$toast.error(err.data.erro, '', { position: 'topRight', timeout: 6000 });
          } else {
            this.$toast.error(`Erro ao alterar status da ferramenta [${ferramenta.nome}].`, '', { position: 'topRight' });
            console.error(`Erro ao alterar status da ferramenta [${ferramenta.nome}].`, err);
          }
        });
    },

    filtrarTipo(tipo) {
      switch (tipo) {
      case 'DADOS':
        return 'Menu :: Dados';
      case 'POWER_UP':
        return 'Menu :: Power Up';
      default:
        return tipo;
      }
    }
  }
};
</script>

<style>
@media screen and (min-width: 800px) {
  .powerups-table table tr td:nth-child(2) {
    max-width: 200px;
  }

  .powerups-table table tr td:nth-child(4) {
    white-space: nowrap !important;
  }
}

@media screen and (max-width: 480px) {
  .bs-powerups {
    width: 191.05px !important;
  }
}
</style>